module.exports = __webpack_public_path__ + "img/vip-study@2x.d93c4c7c.png";